module.exports = __webpack_public_path__ + "static/media/WZ3.130ffba5.jpg";